import React, { useState } from "react"
import { graphql, useStaticQuery } from "gatsby"
import Img from "gatsby-image"
import HomeLayout from "../HomeLayout/HomeLayout"
import CoolLightbox from "../LightBox/CoolLightBox"
const Page2 = ({onChange}) => {
  const [isOpen, setOpen] = useState(false)
  const [currentImageIndex, setCurrentIndex] = useState(0)

  const data = useStaticQuery(graphql`
    query {
      Page2: allFile(
        sort: { order: ASC, fields: name }
        filter: { sourceInstanceName: { eq: "PostProductionPage2" } }
      ) {
        nodes {
          id
          name
          childImageSharp {
            fluid {
              ...GatsbyImageSharpFluid
            }
          }
        }
      }
      PostProductionInfoPage2: allFile(
        sort: { order: ASC, fields: name }
        filter: { sourceInstanceName: { eq: "PostProductionInfoPage2" } }
      ) {
        nodes {
          id
          name
          childImageSharp {
            fluid {
              ...GatsbyImageSharpFluid
            }
          }
        }
      }
    }
  `)

  var images = []
  data.PostProductionInfoPage2.nodes.map(img => {
    var src = img.childImageSharp.fluid.src
    images.push({
      src,
    })
  })


  return (
    <HomeLayout>
        <>
          {data.Page2.nodes.map((img, index) => {
          var idx =index 
          if(idx==6) return <Img fluid={img.childImageSharp.fluid} />
          if(idx>6) idx--;
            return (
              <div
                onClick={() => {
                  setCurrentIndex(idx)
                  setOpen(true)
                  onChange(false)
                }}
              >
                <Img fluid={img.childImageSharp.fluid} />
              </div>
            )
          })}
         <CoolLightbox 
            images={images}
            setCurrentIndex={setCurrentIndex}
            currentImageIndex={currentImageIndex}
            isOpen={isOpen}
            onClose={() =>{ setOpen(false)
              onChange(true)}}
          />
          
        </>
        </HomeLayout>
  )
}
export default Page2

